(function () {
  var theme = window.ChandraTheme;
  if (!theme) return;
  var strings = theme.config.strings;
  var cleanup = [];
  function on(target, event, fn) { target.addEventListener(event, fn); cleanup.push(function () { target.removeEventListener(event, fn); }); }
  var swapping = false;

  function swapProduct(url, push) {
    var page = document.querySelector('[data-product-page]');
    if (!page || swapping) return;
    var sectionId = page.getAttribute('data-section-id');
    var wrapper = document.getElementById('shopify-section-' + sectionId);
    if (!wrapper) { window.location.href = url; return; }
    swapping = true;
    page.classList.add('is-swapping');
    var clean = url.split('#')[0];
    fetch(clean + (clean.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId), { headers: { 'Accept': 'text/html' } }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-product-page]');
      if (!fresh) throw new Error('no section');
      while (cleanup.length) cleanup.pop()();
      page.parentNode.replaceChild(fresh, page);
      var title = fresh.querySelector('.product__title');
      if (title) document.title = title.textContent.trim() + document.title.slice(document.title.indexOf(' | ') > -1 ? document.title.indexOf(' | ') : document.title.length);
      if (push && history.pushState) history.pushState({ chandraProduct: clean }, '', clean);
      swapping = false;
      init();
      var ring = fresh.querySelector('[data-chip-ring]');
      if (ring) ring.classList.add('is-set');
    }).catch(function () { swapping = false; window.location.href = url; });
  }
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.chandraProduct) swapProduct(e.state.chandraProduct, false);
    else if (document.querySelector('[data-product-page]') && /\/products\//.test(window.location.pathname)) swapProduct(window.location.pathname, false);
  });
  if (history.replaceState && /\/products\//.test(window.location.pathname)) history.replaceState({ chandraProduct: window.location.pathname }, '', window.location.href);

  function init() {
  var page = document.querySelector('[data-product-page]');
  if (!page) return;

  var form = page.querySelector('#ProductForm');
  var select = page.querySelector('[data-variant-select]');
  var variants = JSON.parse(page.querySelector('[data-variants]').textContent);
  var optionSets = page.querySelectorAll('.product__options[data-option-index]');
  var priceValue = page.querySelector('[data-price-value]');
  var compare = page.querySelector('[data-compare]');
  var addBtn = page.querySelector('[data-add-btn]');
  var addText = page.querySelector('[data-add-text]');
  var note = page.querySelector('[data-add-note]');
  var stage = page.querySelector('[data-stage]');
  var stageImgs = page.querySelectorAll('.product__stage-img[data-media-id]');
  var thumbs = page.querySelectorAll('[data-thumb]');
  var ring = page.querySelector('[data-thumb-ring]');
  var qtyInput = page.querySelector('[data-qty] input');
  var qtyBox = page.querySelector('.product__buy [data-qty]');
  var stepper = page.querySelector('[data-product-stepper]');
  var countLabel = page.querySelector('[data-product-count]');
  var morphTimer = null;
  var current = 0;

  function syncStepper() {
    if (!stepper || !select.value) return;
    var qty = theme.cartQty(select.value);
    countLabel.textContent = qty;
    if (qty > 0 && !addBtn.hidden && addBtn.classList.contains('is-done')) {
      if (morphTimer) return;
      morphTimer = setTimeout(function () {
        morphTimer = null;
        stepper.hidden = false;
        addBtn.hidden = true;
        if (qtyBox) qtyBox.hidden = true;
        theme.btnState(addBtn, '');
        addText.textContent = strings.add;
      }, 650);
      return;
    }
    if (morphTimer) return;
    stepper.hidden = qty === 0;
    addBtn.hidden = qty > 0;
    if (qtyBox) qtyBox.hidden = qty > 0;
  }
  if (stepper) {
    theme.each(stepper.querySelectorAll('[data-step]'), function (btn) {
      btn.addEventListener('click', function () {
        if (stepper.classList.contains('is-busy')) return;
        var next = theme.cartQty(select.value) + Number(btn.getAttribute('data-step'));
        if (next < 0) return;
        stepper.classList.add('is-busy');
        theme.changeCart(select.value, next).then(function () { stepper.classList.remove('is-busy'); }).catch(function () { stepper.classList.remove('is-busy'); });
      });
    });
    on(document, 'chandra:cart', syncStepper);
    theme.loadCart();
  }

  function moveRing() {
    if (!ring || !thumbs[current]) return;
    var t = thumbs[current];
    ring.style.transform = 'translate(' + t.offsetLeft + 'px,' + t.offsetTop + 'px)';
    ring.style.width = t.offsetWidth + 'px';
    ring.style.height = t.offsetHeight + 'px';
  }

  function showIndex(i) {
    if (!stageImgs.length) return;
    var next = (i + stageImgs.length) % stageImgs.length;
    if (next === current && stageImgs[current].classList.contains('is-on')) return;
    var dir = next > current ? 1 : -1;
    theme.each(stageImgs, function (img, n) {
      img.style.setProperty('--slide', (n === next ? dir : -dir) * 12 + '%');
      img.classList.toggle('is-on', n === next);
    });
    current = next;
    var id = stageImgs[current].getAttribute('data-media-id');
    theme.each(thumbs, function (t) {
      var on = t.getAttribute('data-thumb') === id;
      t.classList.toggle('is-on', on);
      if (on && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
    moveRing();
    if (lightbox && !lightbox.hidden) swapLightbox();
  }

  function showMedia(id) {
    theme.each(stageImgs, function (img, n) { if (img.getAttribute('data-media-id') === String(id)) showIndex(n); });
  }

  function findVariant() {
    var opts = Array.prototype.map.call(optionSets, function (set) {
      var checked = set.querySelector('input:checked');
      return checked ? checked.value : null;
    });
    if (!opts.length) return variants[0];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].options.join('|') === opts.join('|')) return variants[i];
    }
    return null;
  }

  function update() {
    var v = findVariant();
    if (!v) {
      addBtn.disabled = true;
      addText.textContent = strings.unavailable;
      return;
    }
    select.value = v.id;
    priceValue.textContent = v.price;
    if (compare) {
      compare.hidden = !v.compare;
      if (v.compare) compare.textContent = v.compare;
    }
    addBtn.disabled = !v.available;
    addText.textContent = v.available ? strings.add : strings.soldOut;
    syncStepper();
    if (v.media) showMedia(v.media);
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url.toString());
    }
  }

  theme.each(page.querySelectorAll('[data-chips]'), function (chips) {
    var chipRing = chips.querySelector('[data-chip-ring]');
    function moveChipRing() {
      var checked = chips.querySelector('input:checked');
      var label = checked ? chips.querySelector('label[for="' + checked.id + '"]') : chips.querySelector('.product__chip.is-on');
      if (!chipRing || !label) return;
      chipRing.style.transform = 'translate(' + label.offsetLeft + 'px,' + label.offsetTop + 'px)';
      chipRing.style.width = label.offsetWidth + 'px';
      chipRing.style.height = label.offsetHeight + 'px';
      chipRing.classList.add('is-set');
    }
    chipRing.style.transition = 'none';
    moveChipRing();
    setTimeout(function () { chipRing.style.transition = ''; }, 50);
    on(window, 'resize', moveChipRing);
    theme.each(chips.querySelectorAll('.product__chip-input'), function (input) { input.addEventListener('change', function () { moveChipRing(); update(); }); });
    theme.each(chips.querySelectorAll('[data-size-link]'), function (link) {
      link.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || link.classList.contains('is-on')) return;
        e.preventDefault();
        theme.each(chips.querySelectorAll('[data-size-link]'), function (l) { l.classList.remove('is-on'); l.removeAttribute('aria-current'); });
        link.classList.add('is-on');
        link.setAttribute('aria-current', 'page');
        chipRing.style.transform = 'translate(' + link.offsetLeft + 'px,' + link.offsetTop + 'px)';
        chipRing.style.width = link.offsetWidth + 'px';
        chipRing.style.height = link.offsetHeight + 'px';
        chips.classList.add('is-loading');
        swapProduct(link.getAttribute('href'), true);
      });
    });
  });
  theme.each(thumbs, function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });
  var prev = page.querySelector('[data-stage-prev]');
  var next = page.querySelector('[data-stage-next]');
  if (prev) prev.addEventListener('click', function () { showIndex(current - 1); });
  if (next) next.addEventListener('click', function () { showIndex(current + 1); });
  on(window, 'resize', moveRing);
  if (ring) {
    ring.style.transition = 'none';
    moveRing();
    setTimeout(function () { ring.style.transition = ''; }, 50);
  }

  var startX = null;
  if (stage) {
    stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) showIndex(dx < 0 ? current + 1 : current - 1);
      startX = null;
    });
  }

  var lightbox = page.querySelector('[data-lightbox]');
  var lbImg = lightbox ? lightbox.querySelector('[data-lightbox-img]') : null;
  var lbCount = lightbox ? lightbox.querySelector('[data-lightbox-count]') : null;
  var zoomBtn = page.querySelector('[data-zoom]');

  function stageRect() { return stage.getBoundingClientRect(); }

  function place(rect) {
    lbImg.style.top = rect.top + 'px';
    lbImg.style.left = rect.left + 'px';
    lbImg.style.width = rect.width + 'px';
    lbImg.style.height = rect.height + 'px';
  }

  var ratio = 1;
  function targetRect() {
    var vw = window.innerWidth, vh = window.innerHeight;
    var maxW = Math.min(vw * 0.9, 1100), maxH = vh * 0.86;
    var w = maxW, h = w / ratio;
    if (h > maxH) { h = maxH; w = h * ratio; }
    return { top: (vh - h) / 2, left: (vw - w) / 2, width: w, height: h };
  }

  function updateCount() { if (lbCount) lbCount.textContent = (current + 1) + ' / ' + stageImgs.length; }

  function loadFull(img, done) {
    var full = new Image();
    full.onload = function () {
      if (full.naturalWidth && full.naturalHeight) ratio = full.naturalWidth / full.naturalHeight;
      done(full.src);
    };
    full.src = img.getAttribute('data-full');
  }

  function useStage(img) {
    lbImg.src = img.currentSrc || img.src;
    lbImg.alt = img.alt;
    if (img.naturalWidth && img.naturalHeight) ratio = img.naturalWidth / img.naturalHeight;
  }

  function swapLightbox() {
    var img = stageImgs[current];
    lbImg.classList.add('is-swapping');
    setTimeout(function () {
      useStage(img);
      updateCount();
      place(targetRect());
      lbImg.classList.remove('is-swapping');
      loadFull(img, function (src) { if (!lightbox.hidden && stageImgs[current] === img) { lbImg.src = src; place(targetRect()); } });
    }, 250);
  }

  function openLightbox() {
    if (!lightbox) return;
    var img = stageImgs[current];
    useStage(img);
    updateCount();
    lightbox.hidden = false;
    place(stageRect());
    stage.classList.add('is-zoomed');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      void lbImg.offsetWidth;
      lightbox.classList.add('is-open');
      place(targetRect());
    }, 30);
    loadFull(img, function (src) { if (!lightbox.hidden && stageImgs[current] === img) { lbImg.src = src; place(targetRect()); } });
  }

  function closeLightbox() {
    if (!lightbox || lightbox.hidden) return;
    lightbox.classList.remove('is-open');
    place(stageRect());
    document.body.style.overflow = '';
    setTimeout(function () {
      stage.classList.remove('is-zoomed');
      lightbox.hidden = true;
    }, 560);
  }

  if (zoomBtn && stageImgs.length) zoomBtn.addEventListener('click', openLightbox);
  if (stage && stageImgs.length) stage.addEventListener('dblclick', openLightbox);
  if (lightbox) {
    theme.each(lightbox.querySelectorAll('[data-lightbox-close]'), function (el) { el.addEventListener('click', closeLightbox); });
    var lbPrev = lightbox.querySelector('[data-lightbox-prev]');
    var lbNext = lightbox.querySelector('[data-lightbox-next]');
    if (lbPrev) lbPrev.addEventListener('click', function () { showIndex(current - 1); });
    if (lbNext) lbNext.addEventListener('click', function () { showIndex(current + 1); });
    lbImg.addEventListener('click', closeLightbox);
    on(document, 'keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') showIndex(current + 1);
      if (e.key === 'ArrowLeft') showIndex(current - 1);
    });
    on(window, 'resize', function () { if (!lightbox.hidden && lightbox.classList.contains('is-open')) place(targetRect()); });
  }

  var tabs = page.querySelectorAll('[data-tab]');
  var panels = page.querySelectorAll('[data-panel]');
  theme.each(tabs, function (tab) {
    tab.addEventListener('click', function () {
      var key = tab.getAttribute('data-tab');
      theme.each(tabs, function (t) {
        var on = t === tab;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      theme.each(panels, function (p) {
        var on = p.getAttribute('data-panel') === key;
        p.hidden = !on;
        p.classList.toggle('is-on', on);
      });
    });
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (addBtn.disabled || addBtn.classList.contains('is-loading') || addBtn.classList.contains('is-done')) return;
    theme.btnState(addBtn, 'is-loading');
    theme.addToCart(new FormData(form)).then(function (res) {
      if (res.status) { theme.btnState(addBtn, ''); note.textContent = res.description || res.message; return; }
      note.textContent = '';
      theme.btnState(addBtn, 'is-done');
      theme.loadCart(true);
    }).catch(function () { theme.btnState(addBtn, ''); });
  });

  }
  init();
})();
